import { Tutorial } from '@components/tutorial/Tutorial';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '@stores';
import { Step } from 'react-joyride';

export function HubTutorial() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Tutorial.Hub' });
  const { isConnecting, tab } = useAppStore();

  if (tab !== 'hub') return null;
  if (isConnecting) return null;

  const steps: Step[] = [
    {
      target: '.nav-hub',
      placement: 'center',
      content: t('hub0'),
    },
    {
      target: '.nav-hub',
      placement: 'center',
      content: t('hub1'),
    },
    {
      target: '.tutorial-guide',
      placement: 'top',
      content: t('hub2'),
    },
    {
      target: '.tutorial-quest',
      placement: 'top',
      content: t('hub3'),
    },
    {
      target: '.nav-navigation',
      content: <p className="text-primary">{t('hub5')}</p>,
    },
  ];

  return <Tutorial tutorialKey="Hub" steps={steps} />;
}